/**
 * Collect and return any error
 * @param {any} e
 * Error types: EvalError, InternalError, RangeError, ReferenceError, SyntaxError, TypeError, URIError
 */
export class ErrorTrap {
  errorPromise: any;
  errorCallback: Function;

  constructor(callback: Function) {
    this.errorCallback = callback;
  }

  trap = (e: any) => {
    if (e && e.reason) { // if error is handled from promise event, then error will be referenced as e.reason
      e = e.reason;
    }

    if (!e) {
      // <debug>
      console.error('Error trap: No error returned from event'); // log browser console error
      // </debug>

      return;
    }

    // Get the error properties from the error event object
    const { message, filename, lineno, colno, error } = e;
    const stack = e.stack || (error && error.stack) || new Error(message).stack;

    let errorInfo = {
      message,
      filename,
      lineno,
      colno,
      stack,
      type: e.name
    };

    // <debug>
    console.error('Error trap: ', errorInfo); // log browser console error
    // </debug>

    return errorInfo;
  }

  init = () => {
    window.addEventListener('error', this.trap);
    window.addEventListener('unhandledrejection', this.trap);
  }
}

export default ErrorTrap;
